<div class="camera-wrapper">
  @if (!capturedImage) {
    <video #video autoplay playsinline></video>
  }
  <canvas #canvas style="display: none;"></canvas>
  @if (capturedImage) {
    <img [src]="capturedImage" class="captured-image" />
  }

  <div class="camera-controls">
    @if (!capturedImage) {
      <button mat-icon-button color="accent" (click)="capture()" matTooltip="Capture Image">
        <mat-icon>photo_camera</mat-icon>
      </button>
      <button mat-icon-button color="accent" (click)="switchCamera()" matTooltip="Switch Camera">
        <mat-icon>flip_camera_android</mat-icon>
      </button>
    }

    @if (capturedImage) {
      <button mat-icon-button color="accent" (click)="upload()" matTooltip="Upload Image">
        <mat-icon>cloud_upload</mat-icon>
      </button>
      <button mat-icon-button color="accent" (click)="retake()" matTooltip="Retake">
        <mat-icon>refresh</mat-icon>
      </button>
    }
  </div>
  <button mat-icon-button color="warn" class="close-btn" (click)="close()" matTooltip="Close">
    <mat-icon>close</mat-icon>
  </button>
</div>


